/**
 * 適当に配置用の位置と向きを返す
 * @param int seed 整数
 * @return object { pos, dir }
 */
const initialLayout = (seed, pos) => {
	const angle = 0.6 * (seed + 1) * Math.PI
	const radius = 0.6 * seed + 1
	const position =
		(pos.x !== undefined && pos.y !== undefined && pos.z !== undefined) ?
			[
				pos.x,
				pos.y,
				pos.z
			] :
			[
				radius * Math.cos(angle),
				0,
				radius * Math.sin(angle)
			]
	const direction =
		(pos.x !== undefined && pos.y !== undefined && pos.z !== undefined) ?
			[
				-pos.x,
				0,
				-pos.z
			] :
			[
				Math.sin(radius),
				0,
				Math.cos(radius)
			]

	return { position: position, direction: direction }
}

export default initialLayout
